import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    cities: [],
    loading: false,
    citiesInUse: [],
};
export var cities = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
